import React from 'react';

class DoubleRangeSlider extends React.Component {
  state = {
    sliderWidth: 260,
    offsetSliderWidth: 0,
    minValueBetween: this.props.minValueBetween || 10,
    inputMin: this.props.currentMin ? this.props.currentMin : this.props.min ? this.props.min : 0,
    inputMax: this.props.currentMax ? this.props.currentMax : this.props.max ? this.props.max : 10,
    typeDebounce: null,
    finishedDragging: false,
  };

  componentDidMount() {
    const { currentMin, min, currentMax, max } = this.props;

    if (currentMin <= min) {
      this.minValue.style.width = 0 + '%';
    } else {
      this.minValue.style.width = ((currentMin - min) * 100) / (max - min) + '%';
    }

    if (currentMax >= max) {
      this.maxValue.style.width = 100 + '%';
    } else {
      this.maxValue.style.width = ((currentMax - min) * 100) / (max - min) + '%';
    }

    const sliderPos = this.slider.getBoundingClientRect();

    this.setState({
      sliderWidth: sliderPos.width,
      offsetSliderWidth: sliderPos.left,
      inputMin: this.props.currentMin,
      inputMax: this.props.currentMax,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentMin, min, currentMax, max, showDropdown } = this.props;

    if (showDropdown !== prevProps.showDropdown) {
      const sliderPos = this.slider.getBoundingClientRect();

      this.setState({
        sliderWidth: sliderPos.width,
        offsetSliderWidth: sliderPos.left,
      });
    }

    if (prevProps.nbHits !== this.props.nbHits || prevProps.min !== min || prevProps.max !== max) {
      if (currentMin <= min) {
        this.minValue.style.width = 0 + '%';
      } else {
        this.minValue.style.width = ((currentMin - min) * 100) / (max - min) + '%';
      }

      if (currentMax >= max) {
        this.maxValue.style.width = 100 + '%';
      } else {
        this.maxValue.style.width = ((currentMax - min) * 100) / (max - min) + '%';
      }

      const sliderPos = this.slider.getBoundingClientRect();

      this.setState({
        sliderWidth: sliderPos.width,
        offsetSliderWidth: sliderPos.left,
        inputMin: this.props.currentMin,
        inputMax: this.props.currentMax,
      });
    }

    if (this.state.finishedDragging) {
      this.setState({ finishedDragging: false });
      this.props.onRefine({
        currentMin: this.state.inputMin,
        currentMax: this.state.inputMax,
      });
    }
  }

  changeBetween = e => {
    if (e.target === e.currentTarget) {
      const { sliderWidth, offsetSliderWidth } = this.state;
      const x = e.clientX ? e.clientX : e.touches[0].pageX;
      const draggedWidth = x - offsetSliderWidth;
      const draggedWidthInPercent = (draggedWidth * 100) / sliderWidth;

      this.setState({ finishedDragging: true });
      if (draggedWidthInPercent <= 50) {
        this.onMouseMoveMin(e);
      } else {
        this.onMouseMoveMax(e);
      }
    }
  };

  changeMin = e => {
    if (e.target === e.currentTarget) {
      this.setState({ finishedDragging: true });
      this.onMouseMoveMin(e);
    }
  };

  changeMax = e => {
    if (e.target === e.currentTarget) {
      this.setState({ finishedDragging: true });
      this.onMouseMoveMax(e);
    }
  };

  onMouseUpMin = e => {
    this.setState({ finishedDragging: true });
    document.removeEventListener('mouseup', this.onMouseUpMin);
    document.removeEventListener('mousemove', this.onMouseMoveMin);

    document.removeEventListener('touchend', this.onMouseUpMin);
    document.removeEventListener('touchmove', this.onMouseMoveMin);
  };

  changeMinValue = e => {
    e.preventDefault();
    e.stopPropagation();

    document.addEventListener('mousemove', this.onMouseMoveMin);
    document.addEventListener('mouseup', this.onMouseUpMin);

    document.addEventListener('touchmove', this.onMouseMoveMin);
    document.addEventListener('touchend', this.onMouseUpMin);
  };

  onMouseMoveMin = e => {
    const { sliderWidth, offsetSliderWidth } = this.state;
    const { min, max, currentMax, onSetPriceMethod } = this.props;
    const x = e.clientX ? e.clientX : e.touches[0].pageX;
    const minValueThumb = this.minValue;

    const draggedWidth = x - offsetSliderWidth;
    const draggedWidthInPercent = (draggedWidth * 100) / sliderWidth;
    const currentMin = Math.round(min + ((max - min) / 100) * draggedWidthInPercent);
    onSetPriceMethod && onSetPriceMethod('number');

    if (!minValueThumb) {
      return;
    }

    if (currentMin >= currentMax) {
      return;
    }

    if (draggedWidthInPercent <= 0.1) {
      minValueThumb.style.width = 0 + '%';

      this.setState({
        currentMin: min,
        inputMin: min,
      });
    } else if (draggedWidthInPercent >= 99.9) {
      minValueThumb.style.width = 100 + '%';

      this.setState({
        currentMin: max,
        inputMin: max,
      });
    } else {
      minValueThumb.style.width = draggedWidthInPercent + '%';

      this.setState({
        currentMin,
        inputMin: currentMin,
      });
    }
  };

  onMouseUpMax = e => {
    this.setState({ finishedDragging: true });
    document.removeEventListener('mouseup', this.onMouseUpMax);
    document.removeEventListener('mousemove', this.onMouseMoveMax);

    document.removeEventListener('touchend', this.onMouseUpMax);
    document.removeEventListener('touchmove', this.onMouseMoveMax);
  };

  changeMaxValue = e => {
    e.preventDefault();
    e.stopPropagation();

    document.addEventListener('mousemove', this.onMouseMoveMax);
    document.addEventListener('mouseup', this.onMouseUpMax);

    document.addEventListener('touchmove', this.onMouseMoveMax);
    document.addEventListener('touchend', this.onMouseUpMax);
  };

  onMouseMoveMax = e => {
    const { sliderWidth, offsetSliderWidth } = this.state;
    const { min, max, currentMin, onSetPriceMethod } = this.props;
    const maxValueThumb = this.maxValue;
    const x = e.clientX ? e.clientX : e.touches[0].pageX;

    const draggedWidth = x - offsetSliderWidth;
    const draggedWidthInPercent = (draggedWidth * 100) / sliderWidth;
    const currentMax = Math.round(min + ((max - min) / 100) * draggedWidthInPercent);
    onSetPriceMethod && onSetPriceMethod('number');

    if (!maxValueThumb) {
      return;
    }

    if (currentMax <= currentMin) {
      return;
    }

    if (draggedWidthInPercent >= 99.9) {
      maxValueThumb.style.width = 100 + '%';

      this.setState({
        currentMax: max,
        inputMax: max,
      });
    } else if (draggedWidthInPercent <= 0.1) {
      maxValueThumb.style.width = 0 + '%';

      this.setState({
        currentMax: min,
        inputMax: min,
      });
    } else {
      maxValueThumb.style.width = draggedWidthInPercent + '%';

      this.setState({
        currentMax,
        inputMax: currentMax,
      });
    }
  };

  setMin = e => {
    const { minValueBetween } = this.state;
    const { min, max, currentMax, onSetPriceMethod } = this.props;
    onSetPriceMethod && onSetPriceMethod('text');
    //
    const inputMin = e.target.value
      ? e.target.value.charAt(0) === '$'
        ? e.target.value.substring(1)
        : e.target.value
      : '';

    this.setState({
      inputMin: inputMin,
    });

    if (inputMin >= min && inputMin <= currentMax) {
      this.setState({
        currentMin: parseInt(inputMin),
      });

      this.minValue.style.width = (inputMin * 100) / max + '%';
    }
  };

  setMax = e => {
    const { minValueBetween } = this.state;
    const { max, currentMin, onSetPriceMethod } = this.props;
    onSetPriceMethod && onSetPriceMethod('text');
    //
    const inputMax = e.target.value
      ? e.target.value.charAt(0) === '$'
        ? e.target.value.substring(1)
        : e.target.value
      : '';

    this.setState({
      inputMax: inputMax,
    });

    if (inputMax >= currentMin && inputMax <= max) {
      this.setState({
        currentMax: parseInt(inputMax),
      });

      this.maxValue.style.width = (inputMax * 100) / max + '%';
    }
  };

  preventEnter = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  mouseEnter = e => {
    const sliderPos = this.slider.getBoundingClientRect();

    this.setState({
      sliderWidth: sliderPos.width,
      offsetSliderWidth: sliderPos.left,
    });
  };

  debounceType = (e, ext) => {
    clearTimeout(this.state.typeDebounce);
    if (e.target.value) {
      this.setState({
        typeDebounce: setTimeout(ext, 2000),
        finishedDragging: true,
      });
    }
  };

  render() {
    const { inputMin, inputMax } = this.state;
    const { showDollar } = this.props;

    return (
      <>
        <div
          ref={ref => (this.slider = ref)}
          onMouseEnter={this.mouseEnter.bind(this)}
          onClick={this.changeMax.bind(this)}
          id="slider"
        >
          <div ref={ref => (this.minValue = ref)} onClick={this.changeMin.bind(this)} id="min">
            <div
              ref={ref => (this.minValueDrag = ref)}
              id="min-drag"
              onMouseDown={this.changeMinValue.bind(this)}
              onTouchStart={this.changeMinValue.bind(this)}
            />
          </div>

          <div ref={ref => (this.maxValue = ref)} onClick={this.changeBetween.bind(this)} id="max">
            <div
              ref={ref => (this.maxValueDrag = ref)}
              id="max-drag"
              onMouseDown={this.changeMaxValue.bind(this)}
              onTouchStart={this.changeMaxValue.bind(this)}
            />
          </div>

          <div className="values">
            <label htmlFor="min-input" className="price-minimum-label">
              Minimum
            </label>
            <input
              id="min-input"
              type="text"
              onChange={e => this.debounceType(e, this.setMin(e))}
              onKeyPress={this.preventEnter.bind(this)}
              value={(showDollar ? '$' : '') + inputMin}
              autoComplete="off"
            />
            <label htmlFor="max-input" className="price-maximum-label">
              Maximum
            </label>
            <input
              id="max-input"
              type="text"
              onChange={e => this.debounceType(e, this.setMax(e))}
              onKeyPress={this.preventEnter.bind(this)}
              value={(showDollar ? '$' : '') + inputMax}
              autoComplete="off"
            />
          </div>
        </div>
      </>
    );
  }
}

export default DoubleRangeSlider;
